import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';

import { addProduct, updateProduct } from 'redux/actions';

const ProductDetails = (props) => {

  const [values, setValues] = useState({
    name: props.productInfo.name,
    unitCost: props.productInfo.unitCost,
    category: props.productInfo.category,
    company: props.productInfo.company,
    barcode: props.productInfo.barcode
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if(props.update) {
      const updatedProduct = {
        id: props.productInfo.id,
        updates : {
          category: values.category,
          company: values.company,
          name: values.name,
          unitCost: values.unitCost,
          barcode: values.barcode
        }
      };
      props.updateProduct(updatedProduct);
    }
    else {
      const newProduct = {
        displayId: props.productInfo.displayId,
        category: values.category,
        company: values.company,
        name: values.name,
        unitCost: values.unitCost,
        barcode: values.barcode
      };
      props.addProduct(newProduct, props.activeUserId);
    }

    props.cancelAddUpdate();
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited later"
          title="Product"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the Product Name"
                label="Name"
                name="name"
                onChange={handleChange}
                required
                value={values.name}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please select the Product's Category"
                label="Select Category"
                name="category"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.category}
                variant="outlined"
              >
                {props.productCategories.map((option) => (
                  <option
                    key={option.name}
                    value={option.name}
                  >
                    {option.name}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please select the Product's Company"
                label="Select Brand"
                name="company"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.company}
                variant="outlined"
              >
                {props.productCompanies.map((option) => (
                  <option
                    key={option.name}
                    value={option.name}
                  >
                    {option.name}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the Unit Cost of the Product"
                label="Unit Cost"
                name="unitCost"
                onChange={(event) => setValues({ ...values, unitCost: parseFloat(event.target.value) || 0 })}
                required
                value={values.unitCost}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Enter the Product Barcode or Scan it"
                label="Barcode"
                name="barcode"
                onChange={handleChange}
                required
                value={values.barcode}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Save Product
          </Button>
          <Button sx={{ mx: 1 }} onClick={props.cancelAddUpdate}>
            Cancel
          </Button>
        </Box>
      </Card>
    </form>
  )
};

export default connect (null, {addProduct, updateProduct}) (ProductDetails);